module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER TWO")])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('h2', {
    staticClass: "h2title"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("A Potomac Son")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("The summer after Harry Lee sailed down the Potomac, a naval squadron flying the Union Jack headed upriver. Fort Washington on the Maryland bank opposite Mount Vernon had fallen.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#footnote-466-1",
      "id": "footnote-466-1-backlink"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("I")])]), _vm._v(" The Americans guarding the position had chosen to blow up their own magazine for "), _c('a', {
    attrs: {
      "id": "note131"
    }
  }, [_vm._v("reasons no one could quite understand. Only diplomacy could save poor Alexandria from the British now. On the morning of August 29, 1814, the town faced a fearsome sight: two frigates, two rocket ships, two bomb ships, and a schooner formed a battle line stretching from one end of town to the other. Confronting more than a hundred guns, Alexandria’s leaders realized their homes could be ")]), _c('a', {
    attrs: {
      "id": "note132"
    }
  }, [_vm._v("“laid in ashes in a few minutes.” Any doubts about the enemy’s willingness to open fire had disappeared days earlier when flames from Washington, DC, had ")]), _c('a', {
    attrs: {
      "id": "note133"
    }
  }, [_vm._v("illuminated the night sky. The British soldiers had torched the capital’s public buildings. If Alexandria did not surrender, its rows of redbrick buildings would share the fate of the White House and Capitol.")])]), _c('a', {
    attrs: {
      "id": "note133"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note133"
    }
  }, [_vm._v("Alexandria’s Common Council had no choice but to accept ")]), _c('a', {
    attrs: {
      "id": "note134"
    }
  }, [_vm._v("humiliating terms of surrender. Before sailing away, the British loot grew to include ships, flour, tobacco, cotton, wine, and sugar. The invaders also stole what Alexandria’s more than ")]), _c('a', {
    attrs: {
      "id": "note135"
    }
  }, [_vm._v("seven thousand residents held most dear: their pride. Alexandria was not just any Potomac port; it was General George Washington’s hometown. Back in 1749, Washington ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("helped lay out the town’s first ")]), _c('a', {
    attrs: {
      "id": "note136"
    }
  }, [_vm._v("lots. Many years later, when Congress gave the president authority to draw the four ten-mile boundary lines forming the new diamond-shaped District of Columbia, Washington carefully tucked Alexandria into the ")]), _c('a', {
    attrs: {
      "id": "note137"
    }
  }, [_vm._v("bottom corner. No longer part of Virginia, Alexandria owed its prosperity to its position just below the falls of Washington’s favorite river. Wagons from the west brought ")]), _c('a', {
    attrs: {
      "id": "note138"
    }
  }, [_vm._v("wheat to the wharves. Tobacco from the Tidewater filled the markets. By 1814, the wealth from this trade had filled Washington’s grid with taverns and shops. Now British boots had defiled the streets. Alexandria had surrendered without a fight. ")]), _c('a', {
    attrs: {
      "id": "note139"
    }
  }, [_vm._v("“Thanks be to Almighty God that this degraded town no longer forms a part of the state of Virginia!” a Richmond newspaper editorialized. “We would scorn to live in the same State with men who would stoop to kiss the feet of a British officer.”")])]), _c('a', {
    attrs: {
      "id": "note139"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note139"
    }
  }, [_vm._v("The British admiral who led the attack on the nation’s capital confessed that his success owed as much to who had not been present as to who was. ")]), _c('a', {
    attrs: {
      "id": "note140"
    }
  }, [_vm._v("“If General Washington had been president we should never have thought of coming here,” he said. The family that Harry Lee left behind in Alexandria surely would have agreed.")])]), _c('a', {
    attrs: {
      "id": "note140"
    }
  }, [_c('p', {
    staticClass: "secbreak"
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "note140"
    }
  }, [_vm._v("Robert Edward Lee was seven years old when the War of 1812 humiliated Alexandria. Where exactly he spent the occupation, like so much else about his childhood, is unknown. Perhaps his family fled town; ")]), _c('a', {
    attrs: {
      "id": "note141"
    }
  }, [_vm._v("perhaps they huddled at what passed for home at 607 Oronoco Street, the redbrick house that a distant cousin had lent. Harry Lee had abandoned the five surviving children from his second marriage not only to the whims of war but also to the uncertainty of sleeping under roofs not their own. Forced to raise the brood alone, Ann Carter Lee had accepted more burdens than her body could bear. Time would turn her into an invalid.")])]), _c('a', {
    attrs: {
      "id": "note141"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note141"
    }
  }, [_vm._v("That the younger children could hardly remember their father made the oldest brother, Charles Carter Lee, known as Carter, cherish his memories all the more. He could remember Harry sharing old letters from George Washington and other heroes of the Revolution. ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "note142"
    }
  }, [_vm._v("“I have read in their own manuscripts, on the paper touched and folded by their hallowed hands, their public and private communications, all breathing the ardor of patriotism and the counsels of wisdom.” Carter clung to these pages for the rest of his life, as if revisiting nursery rhymes tucked into the first folds of the mind. The stories learned at childhood, he explained, “become entwined with ourselves and mingled with our self-esteem.” Family history was American history. “It would but be mingling the flow of filial affection and patriotic feeling were I to run over our toils and our triumphs from the monumental heights around Boston to the unmarked battle fields of Georgia; for either by his sword or his pen, the memory of my father is connected with them all.”")])]), _c('a', {
    attrs: {
      "id": "note142"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note142"
    }
  }, [_vm._v("From the Caribbean, Harry sent Carter new letters filled with platitudes and advice he hoped would trickle down to Carter’s younger brother, Sydney Smith Lee, known as Smith, and then to his youngest brother, Robert. ")]), _c('a', {
    attrs: {
      "id": "note143"
    }
  }, [_vm._v("“If he is rightly assisted & guided in his education,” Harry wrote of Carter, “he will benefit Smith & Robert greatly.” Some of these letters ")]), _c('a', {
    attrs: {
      "id": "note144"
    }
  }, [_vm._v("disappeared at sea, only to surface after the Lee boys had grown. Nevertheless, their contents offer a glimpse of the lessons Harry Lee wished to convey. ")]), _c('a', {
    attrs: {
      "id": "note145"
    }
  }, [_vm._v("“Dwell on the virtues, and imitate, as far as lies in your power, the great and good men whom history presents to our view,” Harry advised. ")]), _c('a', {
    attrs: {
      "id": "note146"
    }
  }, [_vm._v("“Read therefore the best poets, the best orators, and the best historians.”")])]), _c('a', {
    attrs: {
      "id": "note146"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note146"
    }
  }, [_vm._v("Not surprisingly, Harry Lee hoped that the man he eulogized as first in war and first in peace would remain first in the hearts of the next generation. Throughout his troubles, Harry remained an apostle for Washington’s glory. He allowed others to reprint the funeral oration at ")]), _c('a', {
    attrs: {
      "id": "note147"
    }
  }, [_vm._v("no cost despite desperately needing the money. He once urged Congress to appropriate funds for a Washington mausoleum, which ")]), _c('a', {
    attrs: {
      "id": "note148"
    }
  }, [_vm._v("“will impress a sublime awe” in future generations. “We are deeply interested in holding” up Washington’s virtues “as illustrious models to our sons,” he explained. He recommended his own sons read ")]), _c('a', {
    attrs: {
      "id": "note149"
    }
  }, [_vm._v("“Washington’s official letters wherein the just good honorable man is plainly to be seen even by a young reader.” The boys, Harry wrote, should train themselves to rise before the sun because “the great American soldier ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("and statesman . . . told me himself, that had he not happily been from early life accustomed to rise early, he could never have executed the duty which devolved on him in the course of life.” Regarding the vices that had ruined his own life, Harry instructed Carter, ")]), _c('a', {
    attrs: {
      "id": "note150"
    }
  }, [_vm._v("“Avoid debt, the sink of mental power and the subversion of independence, which draws into debasement even virtue, in appearance certainly, if not in reality. ‘A man ought not only to be virtuous in reality, but he must also always appear so’; thus said to me the great Washington.” While this balance had eluded Harry Lee, he hoped his sons might find it in Washington’s example.")])]), _c('a', {
    attrs: {
      "id": "note150"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note150"
    }
  }, [_vm._v("In writing about Washington’s character, Harry stumbled on deep revelations about his own. In some ways, Washington’s and Harry’s personalities had been similar. Harry described Washington as ")]), _c('a', {
    attrs: {
      "id": "note151"
    }
  }, [_vm._v("“ardent” and “impetuous by nature.” But where equally fiery emotions melted away Harry’s public image and left him pleading “imbecility of mind,” Washington somehow contained “his passions” with “reason.” The secret, in Harry’s opinion, was Washington’s “habitual self-control.” Washington could “repress his inclinations whenever his judgment forbade their indulgence.” By extolling Washington’s self-control, Harry pinpointed the virtue whose absence most explained his own disgrace. With self-control, Washington could hold together his passions as he held together a starving army and thirteen colonies. Without self-control, Harry succumbed to his worst impulses: speculating, swindling, and self-pitying. His mind came apart. Harry’s sons would wonder which of these two courses their own lives would follow. ")]), _c('a', {
    attrs: {
      "id": "note152"
    }
  }, [_vm._v("“The rocks on which I am in the greatest danger of splitting a disposition [are] to aim too high, or at too much,” Carter wrote. “It was this that ruined my great father in dispersing his mighty powers.”")])]), _c('a', {
    attrs: {
      "id": "note152"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note152"
    }
  }, [_vm._v("No one better understood Harry Lee’s vices than his second wife, and she labored to offset them with virtues in her children. Ann taught her sons the “economy” that Washington once faulted their father for lacking. Every child might want something different for dinner—veal for the brothers, fowl for one sister, and fruit for another—but Ann refused to cater to individual tastes. ")]), _c('a', {
    attrs: {
      "id": "note153"
    }
  }, [_vm._v("“As there is to be but one dish, all ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("cannot be pleased,” she said. She urged her children to find “that noble independence of spirit, which would cause you to blush at incurring an expense, you could not in justice to your family afford.” She did not hide the reality of their finances. “We cannot borrow money, because we cannot repay it.” Unlike her husband, she dismissed quick fixes. She considered even friendly wagers as ")]), _c('a', {
    attrs: {
      "id": "note154"
    }
  }, [_vm._v("“wages of iniquity,” which her children must avoid at all cost. ")]), _c('a', {
    attrs: {
      "id": "note155"
    }
  }, [_vm._v("“You must repel every evil and allow yourself to indulge in such habits only as are consistent with religion and morality,” she wrote one son. “Oh that I could impart to you the knowledge gained from the experience of . . . years, then would you be convinced of the vanity of every pursuit not under the control of the most inflexible virtue.” When Ann detected a slight stubbornness in young Robert, she wrote for advice to her sister, who recommended a remedy: ")]), _c('a', {
    attrs: {
      "id": "note156"
    }
  }, [_vm._v("“Whip and pray, and pray and whip.”")])]), _c('a', {
    attrs: {
      "id": "note156"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note156"
    }
  }, [_vm._v("Necessity was an even sterner teacher, driving out whatever vanity Ann could not exorcise. In 1818, ")]), _c('a', {
    attrs: {
      "id": "note157"
    }
  }, [_vm._v("letters arrived dashing whatever faint hopes the family held for Harry Lee’s return. The old man had died on Cumberland Island, Georgia, while attempting to come home. By this time, Carter Lee had enrolled at Harvard, and Smith Lee would soon join the navy. Young Robert would have to assume the role of man of the house. He later recalled that before he progressed far enough in school to read the great poets, he had already become his mother’s ")]), _c('a', {
    attrs: {
      "id": "note158"
    }
  }, [_vm._v("“outdoor agent & confidential messenger.” This is not to say that Robert’s childhood passed without ")]), _c('a', {
    attrs: {
      "id": "note159"
    }
  }, [_vm._v("pleasure. There were swims in the Potomac, romps around a yard filled with white-flowering snowball trees, and days spent hunting. But these fleeting scenes are not the dominant images of Robert’s boyhood. Contemporaries described him as anything but a boy, as a ")]), _c('a', {
    attrs: {
      "id": "note160"
    }
  }, [_vm._v("“devoted daughter” nursing his mother, as a ")]), _c('a', {
    attrs: {
      "id": "note161"
    }
  }, [_vm._v("“housekeeper” doing the marketing, as “an old man” looking after his mother’s finances and cheering her spirits.")])]), _c('a', {
    attrs: {
      "id": "note161"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note161"
    }
  }, [_vm._v("In a sense, Robert gave up the indulgences of boyhood because his father turned down the responsibilities of manhood. ")]), _c('a', {
    attrs: {
      "id": "note162"
    }
  }, [_vm._v("“At the hour when the other school-boys went to play, he hurried home to order his mother’s drive, and would then be seen carrying her in his arms to the ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("carriage, and arranging her cushions with the gentleness of an experienced nurse,” a family friend turned biographer wrote. During these rides, the boy would protect his mother from the elements and the cold. “He would pull from his pocket a great jack-knife and newspaper, and make her laugh with his efforts to improvise curtains, and shut out the intrusive wind which whistled through the crevices of the old family-coach.” When her spirits sagged, he concocted amusements. “With the gravity of an old man,” Robert would warn “that, unless she was cheerful, the drive would not benefit her.” The moments they shared were for her pleasure, not his.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Thus, from an early age, Robert learned to put others’ emotions before his own. Looking back on this childhood, he said, ")]), _c('a', {
    attrs: {
      "id": "note163"
    }
  }, [_vm._v("“I have been for so many years in the habit of repressing my feelings.” The fixations of his father, the mores of his mother, and the austerity of his upbringing left little choice. Robert might want for much, but he would not want for the self-control that separated his father from Washington.")])]), _c('a', {
    attrs: {
      "id": "note163"
    }
  }, [_c('p', {
    staticClass: "secbreak"
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "note163"
    }
  }, [_vm._v("A boy growing up in Alexandria did not have to look far to see Washington. Young ")]), _c('a', {
    attrs: {
      "id": "note164"
    }
  }, [_vm._v("Robert studied at Alexandria Academy, which Washington had endowed in his will for educating children of ")]), _c('a', {
    attrs: {
      "id": "note165"
    }
  }, [_vm._v("“poor and indigent persons.” Robert ran errands in the market where Washington had ")]), _c('a', {
    attrs: {
      "id": "note166"
    }
  }, [_vm._v("trained troops during the French and Indian War. He worshipped at the Episcopal church where Washington had owned a pew. For long stretches, he lived at 607 Oronoco Street, which Washington had ")]), _c('a', {
    attrs: {
      "id": "note167"
    }
  }, [_vm._v("supposedly visited more than almost any other home in town. As a baby, Robert even nursed from a mother known to wear a ")]), _c('a', {
    attrs: {
      "id": "note168"
    }
  }, [_vm._v("locket on her breast with Washington’s picture. The pendant was a gift from the president. The question of how the immediacy of these images influenced Robert’s development has ")]), _c('a', {
    attrs: {
      "id": "note169"
    }
  }, [_vm._v("divided biographers. What causes less debate—and matters more—is that almost everyone in nineteenth-century America revered Washington.")])]), _c('a', {
    attrs: {
      "id": "note169"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note169"
    }
  }), _c('a', {
    attrs: {
      "id": "note170"
    }
  }, [_vm._v("“The name of Washington is constantly on our lips,” Walt Whitman explained, and for good reason. A conversation as simple as asking ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("for directions inevitably led to his name. ")]), _c('a', {
    attrs: {
      "id": "note171"
    }
  }, [_vm._v("“Every thing great and good in America is called Washington; its capitol, its cities, towns, counties, and districts, all bear his name,” a newspaper correspondent noted. Americans celebrated ")]), _c('a', {
    attrs: {
      "id": "note172"
    }
  }, [_vm._v("Washington’s Birthday as a holiday akin to the Fourth of July. No house was complete without his picture. ")]), _c('a', {
    attrs: {
      "id": "note173"
    }
  }, [_vm._v("“The sculptor and the painter will be employed unceasingly to keep pace with the increasing demand,” a congressman predicted. The great Charles Willson Peale alone produced ")]), _c('a', {
    attrs: {
      "id": "note174"
    }
  }, [_vm._v("sixty Washington portraits, one of which hung in the house where ")]), _c('a', {
    attrs: {
      "id": "note175"
    }
  }, [_vm._v("Robert’s mother grew up.")])]), _c('a', {
    attrs: {
      "id": "note175"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note175"
    }
  }, [_vm._v("In this adoration for Washington, visitors from Europe detected the lingering influence of Old World traditions. While touring New York’s slums, English author Charles Dickens found ")]), _c('a', {
    attrs: {
      "id": "note176"
    }
  }, [_vm._v("tavern walls plastered with pictures of Washington and Queen Victoria. A French diplomat saw traces of the ")]), _c('a', {
    attrs: {
      "id": "note177"
    }
  }, [_vm._v("“magical power” of monarchy in “the force of opinion attached to his person throughout the whole of America.” Yet for all the trappings of the Old World, the spread of the Washington cult reflected a distinctly New World ideal: that sons did not have to ")]), _c('a', {
    attrs: {
      "id": "note178"
    }
  }, [_vm._v("follow in the footsteps of their biological fathers, that they could instead follow the example of the father of their country. Of all the duties a mother owed her sons, a popular women’s magazine wrote, ")]), _c('a', {
    attrs: {
      "id": "note179"
    }
  }, [_vm._v("“Especially should she instruct them to revere the memory of the sincerest patriot and wisest man whose deeds lent glory to our revolutionary struggle—the first President of the Republic.”")])]), _c('a', {
    attrs: {
      "id": "note179"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note179"
    }
  }, [_vm._v("Mothers looking for lesson plans had their pick of biographies. ")]), _c('a', {
    attrs: {
      "id": "note180"
    }
  }, [_vm._v("Hundreds of authors lifted their pens in Washington’s honor. No one enjoyed greater success than a writer named Mason Locke Weems. After the president’s death, Parson Weems, as he became known, fired off a note to a publisher: ")]), _c('a', {
    attrs: {
      "id": "note181"
    }
  }, [_vm._v("“Washington, you know is gone! Millions are gaping to read something about him.” Whether that something was fact or fiction mattered little to Weems as he raced to publish what would be the first of many editions of his Washington biography. The book’s popularity said less about Weems’s knowledge of his subject and more about his understanding of how Americans hungered for stories that could humanize their departed hero. Where Weems could ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("not cherry-pick anecdotes, he grew them on made-up cherry trees. Still, for decades, the Washington whom Weems created became the Washington whom Americans revered. By studying this Washington’s virtues, ")]), _c('a', {
    attrs: {
      "id": "note182"
    }
  }, [_vm._v("“every youth,” Weems promised, “may become a Washington.” One Abraham Lincoln remembered devouring the book while growing up in the backwoods of Indiana in ")]), _c('a', {
    attrs: {
      "id": "note183"
    }
  }, [_vm._v("“the earliest days of my being able to read.”")])]), _c('a', {
    attrs: {
      "id": "note183"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note183"
    }
  }, [_vm._v("Boys who opened the editions sold during Robert’s childhood would have connected Weems’s tales with the Lee name. The title page boasted a glowing review attributed to Harry Lee. ")]), _c('a', {
    attrs: {
      "id": "note184"
    }
  }, [_vm._v("“The author has treated this great subject with admirable success in a new way. He turns all the actions of Washington to the encouragement of virtue, by a careful application of numerous exemplifications drawn from the conduct of the founder of our republic.” In other words, Weems had fulfilled Harry Lee’s hope of “holding . . . forth” Washington’s virtues “as illustrious models to our sons.” Robert would later write that the enormous demand for Washington biographies ")]), _c('a', {
    attrs: {
      "id": "note185"
    }
  }, [_vm._v("“speaks greatly in favour of the People . . . and must tend vastly to their benefit in every respect.”")])]), _c('a', {
    attrs: {
      "id": "note185"
    }
  }, [_c('p', {
    staticClass: "secbreak"
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "note185"
    }
  }, [_vm._v("The most anticipated event of Robert’s childhood occurred on October 16, 1824, when the Marquis de Lafayette visited Alexandria. Like his neighbors, Robert must have counted the days until this character from the pages of Washington lore materialized on the streets of town. The French nobleman had made his first voyage to the New World during the American Revolution. Of all the members of George Washington’s military family, Lafayette had come closest to ")]), _c('a', {
    attrs: {
      "id": "note186"
    }
  }, [_vm._v("being a surrogate son. ")]), _c('a', {
    attrs: {
      "id": "note187"
    }
  }, [_vm._v("“Treat him as if he were my son,” Washington instructed a surgeon after a musket ball had ripped through Lafayette’s leg at the Battle of Brandywine. When Lafayette visited Mount Vernon in 1784 after the war, he found his portrait hanging above the mantel. Now the old hero had returned to America for what would become a more than ")]), _c('a', {
    attrs: {
      "id": "note188"
    }
  }, [_vm._v("six-thousand-mile triumphal tour.")])]), _c('a', {
    attrs: {
      "id": "note188"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note188"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Alexandria demanded a spot on the itinerary. ")]), _c('a', {
    attrs: {
      "id": "note189"
    }
  }, [_vm._v("“The citizens of Alexandria are persuaded that you will look upon them with no common interest,” declared an official invitation reminding Lafayette that Alexandria had been where “as a neighbor and a citizen” Washington’s “intercourse was most affectionate and intimate.” How could Lafayette refuse? He understood why Alexandrians claimed his American father as their town father. And while in Alexandria, he could ")]), _c('a', {
    attrs: {
      "id": "note190"
    }
  }, [_vm._v("visit Ann Lee, the widow of the ")]), _c('a', {
    attrs: {
      "id": "note191"
    }
  }, [_vm._v("“enterprising” horseman he had admired during the Revolution.")])]), _c('a', {
    attrs: {
      "id": "note191"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note191"
    }
  }, [_vm._v("Waiting to welcome the sexagenarian as soon as he crossed the Potomac, Alexandrians gathered at the end of the ")]), _c('a', {
    attrs: {
      "id": "note192"
    }
  }, [_vm._v("Long Bridge from Washington. Appointed an ")]), _c('a', {
    attrs: {
      "id": "note193"
    }
  }, [_vm._v("honorary marshal, seventeen-year-old Robert undoubtedly cut an ")]), _c('a', {
    attrs: {
      "id": "note194"
    }
  }, [_vm._v("impressive figure amid the crowd. The ")]), _c('a', {
    attrs: {
      "id": "note195"
    }
  }, [_vm._v("blue sash hugging his ")]), _c('a', {
    attrs: {
      "id": "note196"
    }
  }, [_vm._v("trim waist would have emphasized his ")]), _c('a', {
    attrs: {
      "id": "note197"
    }
  }, [_vm._v("deepening chest. Under the cap shielding his ")]), _c('a', {
    attrs: {
      "id": "note198"
    }
  }, [_vm._v("ruddy face, his dark eyes would have watched Lafayette’s wigged and worn figure come into view. ")]), _c('a', {
    attrs: {
      "id": "note199"
    }
  }, [_vm._v("Fifteen hundred soldiers then led a parade into town. Around three o’clock in the afternoon, the four gray horses pulling Lafayette’s coach reached the intersection of Washington and King Streets. Over the road, the town had erected a ceremonial hundred-foot arch, adorned with portraits of Washington and Lafayette. From a window perch, high above what a newspaper termed ")]), _c('a', {
    attrs: {
      "id": "note200"
    }
  }, [_vm._v("“the multitude in the streets,” a certain ")]), _c('a', {
    attrs: {
      "id": "note201"
    }
  }, [_vm._v("young heiress noticed how handsome Robert appeared as he followed Lafayette through the arch. Her father, George Washington Parke Custis, the ")]), _c('a', {
    attrs: {
      "id": "note202"
    }
  }, [_vm._v("short, ")]), _c('a', {
    attrs: {
      "id": "note203"
    }
  }, [_vm._v("red-faced, balding man riding in the ")]), _c('a', {
    attrs: {
      "id": "note204"
    }
  }, [_vm._v("carriage behind Lafayette’s, would not have approved.")])]), _c('a', {
    attrs: {
      "id": "note204"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note204"
    }
  }, [_vm._v("It was not a grudge against the boy. Custis had heard all about the Lees’ troubles. His wife, Mary Lee Fitzhugh, was the Lees’ ")]), _c('a', {
    attrs: {
      "id": "note205"
    }
  }, [_vm._v("distant cousin, and her generous brother, William Fitzhugh, once ")]), _c('a', {
    attrs: {
      "id": "note206"
    }
  }, [_vm._v("owned their refuge at 607 Oronoco Street. Custis tried, as much as anyone, to fill the void Harry Lee had left. Often he would invite the Lee children to Arlington, the showy neoclassical mansion he had built just upriver from Alexandria. Robert would later credit Custis with being ")]), _c('a', {
    attrs: {
      "id": "note207"
    }
  }, [_vm._v("“all a father could.” That, however, did not mean Custis wanted his daughter ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("eyeing Harry Lee’s boy, not in that way, and especially not on a day when her eyes should have been focused on her father. Custis was, as everyone knew, George Washington’s adopted son, the child of Mount Vernon.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("The next day, Custis led Lafayette and other dignitaries on a cruise down the Potomac to his old boyhood home. A couple of hours into the cruise, the ")]), _c('a', {
    attrs: {
      "id": "note208"
    }
  }, [_vm._v("cannons of Fort Washington fired a salute. There atop the bluff on the opposite bank sat Mount Vernon. A red roof sloped over a piazza offering views so magnificent that Washington had proclaimed his house the most ")]), _c('a', {
    attrs: {
      "id": "note209"
    }
  }, [_vm._v("“pleasantly situated” in America. Awed at the sight, the dignitaries fell to their ")]), _c('a', {
    attrs: {
      "id": "note210"
    }
  }, [_vm._v("knees. On the way up to the house, Custis and Lafayette stopped at a ")]), _c('a', {
    attrs: {
      "id": "note211"
    }
  }, [_vm._v("dilapidated burial vault wedged into the hillside and overgrown with trees. It was Washington’s grave. The time had come for Custis to give a speech, and speech making was what he did best. ")]), _c('a', {
    attrs: {
      "id": "note212"
    }
  }, [_vm._v("“At this awful and impressive moment, when . . . you bend with reverence over the remains of Washington, the child of Mount Vernon presents you with this token,” he declared. Then, to Lafayette, he presented a lock of Washington’s hair set in a gold ring with the words “Pater Patriae” and “Mount Vernon” engraved on either side.")])]), _c('a', {
    attrs: {
      "id": "note212"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note212"
    }
  }, [_vm._v("Memories flooded up the hillside as the two men approached the house. Lafayette remembered how Washington had welcomed him on the piazza forty years earlier and how Custis, then a ")]), _c('a', {
    attrs: {
      "id": "note213"
    }
  }, [_vm._v("blue-eyed, light-haired three-year-old, had waddled in his adoptive father’s massive shadow. ")]), _c('a', {
    attrs: {
      "id": "note214"
    }
  }, [_vm._v("“It was in this portico, in 1784, that you were introduced to me by the general,” Lafayette said. “You were a very little gentleman, with a feather in your hat, and holding fast to one finger of the good general’s remarkable hand, which was all you could do, my dear sir, at that time.” The story of how Custis came to Mount Vernon had begun long before his birth. In 1757, the death of his grandfather Daniel Parke Custis had transformed his grandmother Martha Dandridge Custis into one of Virginia’s wealthiest widows. The ambitious George Washington had wooed and won her hand with the knowledge that the ")]), _c('a', {
    attrs: {
      "id": "note215"
    }
  }, [_vm._v("Custis estate included almost eighteen thousand acres of land and almost three hundred slaves. Because Daniel died without a will, common law granted Martha one-third of the estate while splitting the remainder ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("between her two children, Jacky and Patsy. Marriage to the widow Custis placed Washington in control over her share and in charge of the children’s trusts. The arrangement elevated Washington to the pinnacle of the planter elite and eventually provided the ")]), _c('a', {
    attrs: {
      "id": "note216"
    }
  }, [_vm._v("financial freedom needed to devote his energies to securing America’s freedom.")])]), _c('a', {
    attrs: {
      "id": "note216"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note216"
    }
  }, [_vm._v("For all its advantages, however, the union between George and Martha Washington was not perfect. It produced no children. More devastating, the children from Martha’s first marriage, despite her coddling, did not survive the second. Patsy died in 1773 from complications related to ")]), _c('a', {
    attrs: {
      "id": "note217"
    }
  }, [_vm._v("epilepsy. Away at college, Jacky suffered from a different sort of disease: ")]), _c('a', {
    attrs: {
      "id": "note218"
    }
  }, [_vm._v("indolence. The young heir dropped out of school to marry his sweetheart. As Washington scouted battlefields during the Revolution, Jacky Custis looked for a home for his growing family. He overpaid for a tract above Alexandria. ")]), _c('a', {
    attrs: {
      "id": "note219"
    }
  }, [_vm._v("“Nothing,” he explained, “could have induced Me to have given such Terms, but the unconquerable Desire I had, to live in the Neighbourhood of Mt Vernon.” According to ")]), _c('a', {
    attrs: {
      "id": "note220"
    }
  }, [_vm._v("family lore, Jacky also desired to join Washington in the army. For some reason, he waited until Yorktown. ")]), _c('a', {
    attrs: {
      "id": "note221"
    }
  }, [_vm._v("Catching a fatal illness in camp, the raw soldier passed away in his wife’s arms shortly after the British laid down theirs. Martha had lost her last child. Jacky’s widow, meanwhile, faced a future of raising four children alone. As Washington embraced the two grieving women, he made a decision regarding the youngest of the children: a two-year-old girl named Nelly and the infant George Washington Parke Custis. ")]), _c('a', {
    attrs: {
      "id": "note222"
    }
  }, [_vm._v("“From this moment,” Washington supposedly said, “I adopt his two youngest children as my own.” George Washington Parke Custis would have no memories of this moment, but no one would have more memories of Mount Vernon afterward.")])]), _c('a', {
    attrs: {
      "id": "note222"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note222"
    }
  }, [_vm._v("Now, escorting Lafayette through the familiar rooms, Custis could remember, as he put it, Washington’s ")]), _c('a', {
    attrs: {
      "id": "note223"
    }
  }, [_vm._v("“domestic habits and manners; the routine of his methodical life; what he said and did, when he retired from public cares and duties.” Custis had seen Washington the farmer, who ")]), _c('a', {
    attrs: {
      "id": "note224"
    }
  }, [_vm._v("woke early in the morning, rode around his farms, washed down a hearty dinner with Madeira, wrote in his library, sat with his family at the tea table in the evening, and went to bed at nine. He had ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("seen the immaculate ")]), _c('a', {
    attrs: {
      "id": "note225"
    }
  }, [_vm._v("white horses that pulled the president’s carriage, and the ceremony when Washington laid the ")]), _c('a', {
    attrs: {
      "id": "note226"
    }
  }, [_vm._v("cornerstone for the new Capitol building in the city that would bear his name. Custis had also seen Washington the father: caring but severe, distant yet demanding.")])]), _c('a', {
    attrs: {
      "id": "note226"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note226"
    }
  }, [_vm._v("Custis could never measure up to his adoptive father’s expectations. The influence of an ")]), _c('a', {
    attrs: {
      "id": "note227"
    }
  }, [_vm._v("“indulgent” adoptive mother may explain why. As his sister Nelly remarked, ")]), _c('a', {
    attrs: {
      "id": "note228"
    }
  }, [_vm._v("“Grandmamma always spoiled” Custis because he was “the pride of her heart.” Washington worried as Custis squandered his time at Princeton. ")]), _c('a', {
    attrs: {
      "id": "note229"
    }
  }, [_vm._v("“You are now extending into that stage of life when good or bad habits are formed. When the mind will be turned to things useful and praiseworthy, or to dissipation and vice,” he warned. ")]), _c('a', {
    attrs: {
      "id": "note230"
    }
  }, [_vm._v("Desperate as Custis claimed to be to please Washington, a diversion into “dissipation” of some sort led to his ")]), _c('a', {
    attrs: {
      "id": "note231"
    }
  }, [_vm._v("expulsion from the college. In 1798, Washington shipped the boy to St. John’s College in Annapolis with a note that read, ")]), _c('a', {
    attrs: {
      "id": "note232"
    }
  }, [_vm._v("“Mr. Custis possesses competent talents to fit him for any studies, but they are counteracted by an indolence of mind.” The ")]), _c('a', {
    attrs: {
      "id": "note233"
    }
  }, [_vm._v("experiment lasted less than a year. For all his adoptive father’s hopes, Custis returned to Mount Vernon unable to manage even his ")]), _c('a', {
    attrs: {
      "id": "note234"
    }
  }, [_vm._v("own finances. Washington died recognizing his failure as a parent. ")]), _c('a', {
    attrs: {
      "id": "note235"
    }
  }, [_vm._v("“What is best to be done with him,” he said of Custis in 1799, “I know not.”")])]), _c('a', {
    attrs: {
      "id": "note235"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note235"
    }
  }, [_vm._v("Where Custis should reside posed the most pressing question after Martha Washington followed her husband to the grave in 1802. Custis could not stay at Mount Vernon, because George Washington had left the property to a nephew, United States Supreme Court Justice ")]), _c('a', {
    attrs: {
      "id": "note236"
    }
  }, [_vm._v("Bushrod Washington. There were the hereditary Custis lands, including the valuable White House plantation in Virginia’s New Kent County, but those were far from home. There was also the ")]), _c('a', {
    attrs: {
      "id": "note237"
    }
  }, [_vm._v("tree-covered hill that Jacky had purchased overlooking the Potomac, land now lying inside the new District of Columbia. Custis would eventually call the spot Arlington. After an ")]), _c('a', {
    attrs: {
      "id": "note238"
    }
  }, [_vm._v("attempt to buy Mount Vernon failed, Custis headed upriver. If he could not own Mount Vernon, he would bring its spirit to Arlington.")])]), _c('a', {
    attrs: {
      "id": "note238"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note238"
    }
  }, [_vm._v("Now, as Custis and Lafayette finished touring Mount Vernon, ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("someone observed how ")]), _c('a', {
    attrs: {
      "id": "note239"
    }
  }, [_vm._v("“every thing in the house” was as it had been. But that was not so. Gone were the tea-and-table china designed for the veterans of the Revolution and adorned with the crest of their Society of the Cincinnati. Gone were the silver plate, the punch bowl, the family portraits, and even beds and curtains. Martha Washington had left ")]), _c('a', {
    attrs: {
      "id": "note240"
    }
  }, [_vm._v("these treasures to Custis in her will. Gone also were Washington’s ")]), _c('a', {
    attrs: {
      "id": "note241"
    }
  }, [_vm._v("carriage and the tent that housed his headquarters during the war. Custis had bid $610 for the former and $161 for the latter at auction. Ironically, to buy these and other relics, Custis violated his adoptive father’s warnings about ")]), _c('a', {
    attrs: {
      "id": "note242"
    }
  }, [_vm._v("debt.")])]), _c('a', {
    attrs: {
      "id": "note242"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note242"
    }
  }, [_vm._v("At Arlington, Custis stashed the memorabilia in a dilapidated cottage near the river until the ")]), _c('a', {
    attrs: {
      "id": "note243"
    }
  }, [_vm._v("dampness destroyed two paintings. To save his collection, he decided to build a ")]), _c('a', {
    attrs: {
      "id": "note244"
    }
  }, [_vm._v("new home high on the hill. He hired architect George Hadfield to design a mansion that could serve as a “Washington treasury.” Hadfield, who had spent several thankless years supervising the US Capitol’s construction across the river, modeled Arlington House after a classical temple, complete with a faux-marble portico and pediment. The first bricks laid in 1803 might have dried in molds Custis had purchased from Mount Vernon. Fifteen years later, as the eight-columned front neared completion, the house made headlines when a lightning bolt ripped through the roof but caused little damage.")])]), _c('a', {
    attrs: {
      "id": "note244"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note244"
    }
  }, [_vm._v("A Washington monument long before an obelisk across the river would steal that distinction, Arlington was the physical manifestation of Custis’s life mission: to preserve his adoptive father’s legacy. An ")]), _c('a', {
    attrs: {
      "id": "note245"
    }
  }, [_vm._v("amateur artist, Custis hung his own oversized Revolutionary battle paintings among a collection featuring Charles Willson Peale’s 1772 portrait of George Washington. Though one room housed the bed where Washington died—Custis claimed to have left the bedding ")]), _c('a', {
    attrs: {
      "id": "note246"
    }
  }, [_vm._v("“in precisely the same condition”—Arlington House felt very much alive. Thousands tramped across the lawn for picnics every year. An annual ")]), _c('a', {
    attrs: {
      "id": "note247"
    }
  }, [_vm._v("sheep-shearing festival paid homage to Washington’s oft-forgotten work as a pioneer of American agriculture. Custis awarded prizes and showcased his own efforts to produce fine wool from rams and ewes ")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("bred, in part, from the Mount Vernon flock. With the Washington war tent pitched on the lawn, guests sporting homespun clothes drank American wines while Custis gave his orations in a voice his daughter recalled as ")]), _c('a', {
    attrs: {
      "id": "note248"
    }
  }, [_vm._v("“melodious” but others found ")]), _c('a', {
    attrs: {
      "id": "note249"
    }
  }, [_vm._v("tedious. Out of these celebrations of Washington’s spirit emerged an early vision of American nationalism. The view looking down from Arlington Heights somehow justified the vast but still mostly vacant grand avenues that the capital’s designers had sketched out across the river.")])]), _c('a', {
    attrs: {
      "id": "note249"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note249"
    }
  }, [_vm._v("Lafayette himself declared the view from Arlington’s portico ")]), _c('a', {
    attrs: {
      "id": "note250"
    }
  }, [_vm._v("“the finest he had ever seen.” At least a few times before returning to France, he visited the place. At least once, Robert E. Lee ")]), _c('a', {
    attrs: {
      "id": "note251"
    }
  }, [_vm._v("met him there. Hearing Custis’s stories while peering into the relic-filled rooms left an indelible impression. Of Arlington, Robert said, ")]), _c('a', {
    attrs: {
      "id": "note252"
    }
  }, [_vm._v("“My affections & attachments are more strongly placed than at any other place in the World.”")])]), _c('a', {
    attrs: {
      "id": "note252"
    }
  }, [_c('p', {
    staticClass: "secbreak"
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "note252"
    }
  }, [_vm._v("However strong his attachments, Robert could not stick around Arlington and Alexandria. Unlike Custis, he needed to earn a living. Shortly before dying, George Washington had ")]), _c('a', {
    attrs: {
      "id": "note253"
    }
  }, [_vm._v("reaffirmed his support for creating a national military academy. By 1824, the academy founded at West Point on the Hudson River north of New York City had sufficient funding to educate ")]), _c('a', {
    attrs: {
      "id": "note254"
    }
  }, [_vm._v("250 cadets free of charge, a factor not inconsequential to the Lee family. Robert had rapidly advanced in mathematics. During a lesson on conic sections, a teacher admired how he ")]), _c('a', {
    attrs: {
      "id": "note255"
    }
  }, [_vm._v("“drew each one with as much accuracy and finish, lettering and all, as if it was to be engraved and printed.” That aptitude suited him for a military education focused on engineering. Though Ann Lee ")]), _c('a', {
    attrs: {
      "id": "note256"
    }
  }, [_vm._v("opposed the idea—she ")]), _c('a', {
    attrs: {
      "id": "note257"
    }
  }, [_vm._v("could not imagine how she could live without her son—Robert requested a nomination. Unfortunately, so did many other young men. ")]), _c('a', {
    attrs: {
      "id": "note258"
    }
  }, [_vm._v("Applications poured in to the secretary of war, who was at that time South Carolina’s John C. Calhoun. Not yet ")]), _c('a', {
    attrs: {
      "id": "note259"
    }
  }, [_vm._v("the staunch supporter of states’ rights he would become, Calhoun oversaw an institution drawing students from across the country.")])]), _c('a', {
    attrs: {
      "id": "note259"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "note259"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("To distinguish Robert’s application from the pile, his family and friends tapped every possible connection. William Fitzhugh, Custis’s brother-in-law, arranged for Robert to personally deliver a recommendation to Calhoun. The letter asked that whatever Calhoun decide, he decide quickly. Given the Lees’ financial struggles, Robert could afford to ")]), _c('a', {
    attrs: {
      "id": "note260"
    }
  }, [_vm._v("“lose no time in selecting the employment to which his future life is to be devoted.” The letter also mentioned the debt that the United States owed the family. “He is the son of Genl Henry Lee, with whose history, you are, of course, acquainted; and who (whatever may have been the misfortune of his latter years) had certainly established, by his revolutionary services, a strong claim to the gratitude of his country.” Other recommendations testified to Robert’s ")]), _c('a', {
    attrs: {
      "id": "note261"
    }
  }, [_vm._v("“gentlemanly deportment” and ")]), _c('a', {
    attrs: {
      "id": "note262"
    }
  }, [_vm._v("“excellent disposition.” If these testimonials proved wanting, the support of George Washington’s adopted daughter, the lovely Nelly, may have clinched the case. Custis’s sister was said to have ")]), _c('a', {
    attrs: {
      "id": "note263"
    }
  }, [_vm._v("“interested herself very much in obtaining his commission.”")])]), _c('a', {
    attrs: {
      "id": "note263"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Such a connected, talented, and mature young man—who had come of age in Washington’s hometown and learned the self-control Harry Lee lacked—belonged at West Point. Washington had envisioned the cadets as the next generation of military leaders, and, starting in the summer of 1825, Robert E. Lee would stand among them. As Robert bid farewell to the scenes of his childhood, he must have known he would one day return. His attachment to Arlington held strong not only because of what the house represented but also because of who lived there: Custis’s daughter, Mary.")]), _vm._v(" "), _c('hr', {
    staticClass: "hr"
  })]), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "note263"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#footnote-466-1-backlink",
      "id": "footnote-466-1"
    }
  }, [_vm._v("I")]), _vm._v(". At the time, Fort Washington was often called Fort Warburton.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c60927b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 90
// module chunks = 0